webpackJsonp([213231404188204],{

/***/ 1534:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(4);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _withStyles = __webpack_require__(3);
	
	var _withStyles2 = _interopRequireDefault(_withStyles);
	
	var _gatsbyLink = __webpack_require__(15);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _Container = __webpack_require__(5);
	
	var _Container2 = _interopRequireDefault(_Container);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var BgSectionExternal2 = function BgSectionExternal2(_ref) {
	    var children = _ref.children,
	        classes = _ref.classes,
	        className = _ref.className,
	        image = _ref.image,
	        secImage = _ref.secImage,
	        secTitle = _ref.secTitle,
	        secLink = _ref.secLink,
	        secButton = _ref.secButton,
	        bgImage = _ref.bgImage;
	
	    return _react2.default.createElement(
	        "div",
	        { className: (0, _classnames2.default)(classes.root, className) },
	        _react2.default.createElement(
	            "div",
	            { className: classes.titlearea, style: { backgroundImage: "url(" + bgImage + ")", backgroundSize: "cover" } },
	            _react2.default.createElement(
	                _Container2.default,
	                null,
	                _react2.default.createElement(
	                    "div",
	                    { className: classes.flexContainer },
	                    _react2.default.createElement(
	                        "div",
	                        { className: classes.flexItem, style: { paddingLeft: "20px", paddingRight: "30px", paddingTop: "60px" } },
	                        _react2.default.createElement(
	                            "h1",
	                            { className: classes.leftheading },
	                            secTitle
	                        ),
	                        _react2.default.createElement(
	                            "p",
	                            { className: classes.leftsubtext },
	                            children
	                        ),
	                        _react2.default.createElement(
	                            "a",
	                            { href: secLink, className: classes.ctabutton, target: "_blank" },
	                            secButton
	                        )
	                    ),
	                    _react2.default.createElement(
	                        "div",
	                        { className: classes.flexItem2 },
	                        secImage && _react2.default.createElement("img", { src: secImage, className: classes.image,
	                            alt: secTitle })
	                    )
	                )
	            )
	        )
	    );
	};
	
	exports.default = (0, _withStyles2.default)(function (theme) {
	    var _root, _leftheading, _leftsubtext, _flexContainer, _flexItem, _flexItem2;
	
	    return {
	        root: (_root = {
	            display: "flex",
	            flexDirection: "column",
	            minHeight: "200px",
	            overflow: "hidden"
	
	        }, _root[theme.breakpoints[900]] = {
	            minHeight: "400px"
	        }, _root),
	
	        image: {
	            paddingLeft: "15px",
	            width: "100%",
	            height: "100%",
	            paddingTop: "10px",
	            display: "block"
	        },
	        leftheading: (_leftheading = {
	            color: theme.colors.secondary,
	            fontSize: "32px",
	            lineHeight: "40px",
	            fontWeight: "700",
	            marginRight: "auto",
	            paddingBottom: "20px"
	
	        }, _leftheading[theme.breakpoints[900]] = {
	            fontSize: "32px"
	        }, _leftheading),
	        leftsubtext: (_leftsubtext = {
	            color: "#f7f7f7",
	            fontWeight: "500",
	            fontSize: "16px",
	            letterSpacing: ".25px",
	            lineHeight: "24px",
	            marginbottom: "20px",
	            textAlign: "left"
	        }, _leftsubtext[theme.breakpoints[900]] = {
	            fontSize: "16px"
	        }, _leftsubtext),
	        ctabutton: {
	            alignContent: "center",
	            justifyContent: "center",
	            fontSize: "14px",
	            textAlign: "center",
	            fontWeight: "700",
	            minWidth: "300px",
	            letterSpacing: ".25px",
	            backgroundColor: theme.colors.secondary,
	            color: "#FFF",
	            display: "block",
	            marginTop: "30px",
	            maxWidth: "300px",
	            textDecoration: "none",
	            padding: "14px 16px",
	            borderRadius: "3px"
	        },
	
	        flexContainer: (_flexContainer = {
	            padding: "0",
	            margin: '0',
	
	            display: "-webkit-box"
	        }, _flexContainer["display"] = "-moz-box", _flexContainer["display"] = "-ms-flexbox", _flexContainer["display"] = "-webkit-flex", _flexContainer["display"] = "flex", _flexContainer.flexWrap = "wrap", _flexContainer.alignItems = "stretch", _flexContainer),
	        flexItem: (_flexItem = {
	            height: "100%",
	            maxWidth: "100%",
	            width: "100%",
	            paddingTop: "45px",
	            paddingBottom: "45px"
	
	        }, _flexItem[theme.breakpoints[900]] = {
	            maxWidth: "50%",
	            width: "50%",
	            paddingTop: "65px",
	            paddingRight: "25px"
	
	        }, _flexItem),
	
	        flexItem2: (_flexItem2 = {
	            height: "100%",
	            width: "100%",
	            paddingTop: "48px",
	            padding: "0px",
	            margin: "0",
	            alignSelf: "flex-end"
	
	        }, _flexItem2[theme.breakpoints[900]] = {
	            width: "50%",
	            paddingTop: "65px",
	            padding: "0px"
	        }, _flexItem2)
	    };
	})(BgSectionExternal2);
	module.exports = exports["default"];

/***/ }),

/***/ 1641:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(4);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _withStyles = __webpack_require__(3);
	
	var _withStyles2 = _interopRequireDefault(_withStyles);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var WebinarCard = function WebinarCard(_ref) {
	  var classes = _ref.classes,
	      className = _ref.className,
	      webinar = _ref.webinar;
	
	  return _react2.default.createElement(
	    "div",
	    { className: (0, _classnames2.default)(classes.root, className) },
	    _react2.default.createElement(
	      "div",
	      { className: classes.top },
	      _react2.default.createElement(
	        "div",
	        { className: classes.day },
	        webinar.day
	      ),
	      _react2.default.createElement(
	        "a",
	        {
	          href: webinar.registrationUrl,
	          target: "_blank",
	          rel: "noopener noreferrer",
	          className: classes.registerLink
	        },
	        "Register"
	      )
	    ),
	    _react2.default.createElement(
	      "div",
	      { className: classes.details },
	      _react2.default.createElement(
	        "div",
	        { className: classes.detailsTop },
	        _react2.default.createElement(
	          "div",
	          { className: classes.title },
	          webinar.title
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: classes.desc },
	          webinar.description
	        )
	      ),
	      _react2.default.createElement(
	        "div",
	        { className: classes.detailsBottom },
	        _react2.default.createElement(
	          "div",
	          { className: classes.time },
	          webinar.time
	        )
	      )
	    )
	  );
	};
	
	exports.default = (0, _withStyles2.default)(function (theme) {
	  return {
	    root: {
	      display: "flex",
	      flexDirection: "column",
	      alignItems: "center",
	      justifyContent: "stretch",
	      width: "100%",
	      background: "#fff",
	      borderRadius: "6px",
	      boxShadow: "0 8px 12px rgba(0,0,0,0.1)"
	    },
	    top: {
	      display: "flex",
	      justifyContent: "space-between",
	      alignItems: "center",
	      width: "100%",
	      padding: "12px 20px",
	      borderBottom: "2px solid rgba(100, 97, 110, .10)"
	    },
	    day: {
	      fontSize: "18px",
	      fontWeight: "700"
	    },
	    registerLink: {
	      display: "flex",
	      alignContent: "center",
	      justifyContent: "center",
	      backgroundColor: "#55C3BA",
	      fontSize: "14px",
	      letterSpacing: ".25px",
	      color: "#fff",
	      textDecoration: "none",
	      fontWeight: "600",
	      padding: "12px 16px",
	      borderRadius: "6px",
	      alignSelf: "flex-end",
	      marginLeft: "4px"
	    },
	    desc: {
	      color: "#64616E",
	      lineHeight: "22px",
	      paddingBottom: "4px"
	    },
	    details: {
	      display: "flex",
	      flexDirection: "column",
	      padding: "12px 20px",
	      marginRight: "auto",
	      flex: "1"
	    },
	    detailsBottom: {
	      marginTop: "auto"
	    },
	    detailsTop: {
	      paddingBottom: "10px"
	    },
	    time: {
	      fontSize: "16px",
	      fontWeight: "600"
	    },
	    title: {
	      fontSize: "18px",
	      fontWeight: "600",
	      paddingBottom: "8px"
	    }
	  };
	})(WebinarCard);
	module.exports = exports["default"];

/***/ }),

/***/ 1249:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(4);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _withStyles = __webpack_require__(3);
	
	var _withStyles2 = _interopRequireDefault(_withStyles);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var WebinarCardGrid = function WebinarCardGrid(_ref) {
	  var classes = _ref.classes,
	      className = _ref.className,
	      children = _ref.children;
	
	  return _react2.default.createElement(
	    "div",
	    { className: (0, _classnames2.default)(classes.root, className) },
	    children
	  );
	};
	
	exports.default = (0, _withStyles2.default)(function (theme) {
	  var _root;
	
	  return {
	    root: (_root = {
	      display: "grid",
	      justifyContent: "center",
	      gridTemplateColumns: "repeat(1, 1fr)",
	      gridColumnGap: "44px",
	      gridRowGap: "32px"
	
	    }, _root[theme.breakpoints[600]] = {
	      gridTemplateColumns: "repeat(1, 400px)"
	    }, _root[theme.breakpoints[900]] = {
	      gridTemplateColumns: "repeat(2, 400px)"
	    }, _root)
	  };
	})(WebinarCardGrid);
	module.exports = exports["default"];

/***/ }),

/***/ 3070:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/crm_pic.4ccb41ae.png";

/***/ }),

/***/ 3083:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/elevate_crm.ee7275c6.gif";

/***/ }),

/***/ 3095:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/emerge_screen.67578a0d.png";

/***/ }),

/***/ 3152:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/list_pic.272c1ca8.png";

/***/ }),

/***/ 3161:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/miles_pic.045e81a0.png";

/***/ }),

/***/ 1371:
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI1MCIgaGVpZ2h0PSI0MCI+PHBhdGggZD0iTTQwIDEwTDM2LjY3IDBoLTIuMTFsMy4zMyAxMEgyMGwtMi4yOCA2Ljg0TDEyLjExIDBIMTBsNi42NyAyMEgxMGwtMi4yOCA2Ljg0TDIuMTEgMTAgNS40NCAwaC0yLjFMMCAxMGw2LjY3IDIwLTMuMzQgMTBoMi4xMWwyLjI4LTYuODRMMTAgNDBoMjBsMi4yOC02Ljg0TDM0LjU2IDQwaDIuMWwtMy4zMy0xMEg0MGwyLjI4LTYuODRMNDcuODkgNDBINTBsLTYuNjctMjBMNTAgMGgtMi4xbC01LjYyIDE2Ljg0TDQwIDEwem0xLjIzIDEwbC0yLjI4LTYuODRMMzQgMjhoNC41NmwyLjY3LTh6bS0xMC42NyA4bC0yLTZoLTkuMTJsMiA2aDkuMTJ6bS0xMi44NC00Ljg0TDEyLjc3IDM4aDE1Ljc5bDIuNjctOEgyMGwtMi4yOC02Ljg0ek0xOC43NyAyMEgzMGwyLjI4IDYuODRMMzcuMjMgMTJIMjEuNDRsLTIuNjcgOHptLTcuMzMgMkgxNmwtNC45NSAxNC44NEw4Ljc3IDMwbDIuNjctOHoiIGZpbGw9IiNmNmRjZGEiIGZpbGwtcnVsZT0iZXZlbm9kZCIvPjwvc3ZnPg=="

/***/ }),

/***/ 3225:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/webbottom_bg.5ec5aebd.jpg";

/***/ }),

/***/ 3226:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/webinars.ab52ba8e.gif";

/***/ }),

/***/ 3228:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/webtop_bg.d6c324a9.jpg";

/***/ }),

/***/ 1743:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(15);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _withStyles = __webpack_require__(3);
	
	var _withStyles2 = _interopRequireDefault(_withStyles);
	
	var _WebinarCardGrid = __webpack_require__(1249);
	
	var _WebinarCardGrid2 = _interopRequireDefault(_WebinarCardGrid);
	
	var _WebinarCard = __webpack_require__(1641);
	
	var _WebinarCard2 = _interopRequireDefault(_WebinarCard);
	
	var _BgSectionExternal = __webpack_require__(1534);
	
	var _BgSectionExternal2 = _interopRequireDefault(_BgSectionExternal);
	
	var _Container = __webpack_require__(5);
	
	var _Container2 = _interopRequireDefault(_Container);
	
	var _webtop_bg = __webpack_require__(3228);
	
	var _webtop_bg2 = _interopRequireDefault(_webtop_bg);
	
	var _webbottom_bg = __webpack_require__(3225);
	
	var _webbottom_bg2 = _interopRequireDefault(_webbottom_bg);
	
	var _webinars = __webpack_require__(3226);
	
	var _webinars2 = _interopRequireDefault(_webinars);
	
	var _miles_pic = __webpack_require__(3161);
	
	var _miles_pic2 = _interopRequireDefault(_miles_pic);
	
	var _crm_pic = __webpack_require__(3070);
	
	var _crm_pic2 = _interopRequireDefault(_crm_pic);
	
	var _list_pic = __webpack_require__(3152);
	
	var _list_pic2 = _interopRequireDefault(_list_pic);
	
	var _emerge_screen = __webpack_require__(3095);
	
	var _emerge_screen2 = _interopRequireDefault(_emerge_screen);
	
	var _elevate_crm = __webpack_require__(3083);
	
	var _elevate_crm2 = _interopRequireDefault(_elevate_crm);
	
	var _SEO = __webpack_require__(6);
	
	var _SEO2 = _interopRequireDefault(_SEO);
	
	var _overlappingHexagons = __webpack_require__(1371);
	
	var _overlappingHexagons2 = _interopRequireDefault(_overlappingHexagons);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var days = ["Every Monday", "Every Tuesday", "Every Wednesday", "Every Thursday", "Every Friday", "Every Saturday", "Every Sunday"];
	
	var Webinars = function Webinars(_ref) {
	  var classes = _ref.classes,
	      data = _ref.data;
	
	  var webinars = data.allContentfulWebinar.edges;
	  var orderedWebinars = [].concat(webinars).sort(function (a, b) {
	    return days.indexOf(a.node.day) > days.indexOf(b.node.day);
	  });
	  return _react2.default.createElement(
	    "div",
	    { className: classes.root },
	    _react2.default.createElement(_SEO2.default, null),
	    _react2.default.createElement(
	      "div",
	      { style: { backgroundImage: "url(" + _webtop_bg2.default + ")", backgroundSize: "cover", backgroundPosition: "centerBottom" } },
	      _react2.default.createElement(
	        _Container2.default,
	        null,
	        _react2.default.createElement(
	          "div",
	          { className: classes.top, style: { paddingBottom: "90px", paddingRight: "25px", paddingLeft: "25px", paddingTop: "95px" } },
	          _react2.default.createElement(
	            "div",
	            { className: classes.centerHeading },
	            _react2.default.createElement(
	              "div",
	              { className: classes.heading, style: { color: "#ffffff", paddingBottom: "15px" } },
	              "The Power of LEARNING"
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: classes.subtext, style: { color: "#f7f7f7", fontSize: "18px", lineHeight: "26px" } },
	              "Training webinars for Elevate subscribers,",
	              _react2.default.createElement("br", null),
	              "all from the comfort of your couch"
	            )
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      "div",
	      { style: { textAlign: "center", backgroundColor: "#f7f7f7" } },
	      _react2.default.createElement(
	        _Container2.default,
	        null,
	        _react2.default.createElement(
	          "div",
	          { style: { paddingTop: "40px", paddingLeft: "45px", paddingRight: "45px" } },
	          _react2.default.createElement(
	            "div",
	            { className: classes.heading2 },
	            "Live Training Webinars"
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: classes.top },
	          _react2.default.createElement(
	            "div",
	            { className: classes.column2, style: { textAlign: "center", paddingTop: "22px" } },
	            _react2.default.createElement(
	              "div",
	              { className: classes.subheading },
	              "Welcome to Elevate"
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: classes.subtext },
	              "Join your Digital Tour Guide for an introduction to the POWER of Elevate. This popular training is complemented by best practices for engaging your sphere of influence, as well as tips for getting the most out of all that Elevate",
	              _react2.default.createElement("br", null),
	              "has to offer you and your business.",
	              _react2.default.createElement("br", null),
	              _react2.default.createElement("br", null),
	              "Training time:  1 hr."
	            ),
	            _react2.default.createElement(
	              "a",
	              { target: "_blank", href: "https://gateway.on24.com/wcc/eh/3767195/lp/3993321/welcome-to-elevate", className: classes.getStartedLink },
	              "Register Now"
	            ),
	            _react2.default.createElement(
	              "div",
	              { style: { textAlign: "center", paddingTop: "5px" } },
	              _react2.default.createElement("img", { src: _elevate_crm2.default, width: "440" })
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: classes.column2, style: { textAlign: "center", paddingTop: "22px" } },
	            _react2.default.createElement(
	              "div",
	              { className: classes.subheading },
	              "Elevate CRM\xAE"
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: classes.subtext },
	              "Enjoy a step-by-step overview of your",
	              _react2.default.createElement("br", null),
	              "Elevate CRM\xAE. We\u2019ll cover lead management,",
	              _react2.default.createElement("br", null),
	              "managing your website, creating email",
	              _react2.default.createElement("br", null),
	              "campaigns, social media, CMA\u2019s,",
	              _react2.default.createElement("br", null),
	              "analytics and much, much more.",
	              _react2.default.createElement("br", null),
	              _react2.default.createElement("br", null),
	              "Training time:  1 hr."
	            ),
	            _react2.default.createElement(
	              "a",
	              { target: "_blank", href: "https://gateway.on24.com/wcc/eh/3767195/lp/3993323/elevate-crm-training", className: classes.getStartedLink },
	              "Register Now"
	            ),
	            _react2.default.createElement(
	              "div",
	              { style: { textAlign: "center", paddingTop: "5px" } },
	              _react2.default.createElement("img", { src: _crm_pic2.default, width: "300" })
	            )
	          ),
	          _react2.default.createElement("a", { id: "learn_more" })
	        )
	      )
	    ),
	    _react2.default.createElement(
	      "div",
	      { style: { textAlign: "center" } },
	      _react2.default.createElement(
	        _Container2.default,
	        null,
	        _react2.default.createElement(
	          "div",
	          { className: classes.top, style: { paddingTop: "22px" } },
	          _react2.default.createElement(
	            "div",
	            { className: classes.column2, style: { textAlign: "center", paddingTop: "22px" } },
	            _react2.default.createElement(
	              "div",
	              { className: classes.subheading },
	              "Exploring Social Media"
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: classes.subtext },
	              "Are you ready to take your social media marketing to the next level? In this fast-paced session, we\u2019ll explore social marketing techniques designed to increase reach and engagement, and how Elevate helps to empower you with all",
	              _react2.default.createElement("br", null),
	              "of the tools you need to succeed.",
	              _react2.default.createElement("br", null),
	              _react2.default.createElement("br", null),
	              "Training time:  1 hr."
	            ),
	            _react2.default.createElement(
	              "a",
	              { target: "_blank", href: "https://gateway.on24.com/wcc/eh/3767195/lp/3993325/exploring-social-media", className: classes.getStartedLink },
	              "Register Now"
	            ),
	            _react2.default.createElement(
	              "div",
	              { style: { textAlign: "center", paddingTop: "5px" } },
	              _react2.default.createElement("img", { src: _list_pic2.default, width: "300" })
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: classes.column2, style: { textAlign: "center", paddingTop: "22px" } },
	            _react2.default.createElement(
	              "div",
	              { className: classes.subheading },
	              "Elevate Email Campaigns"
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: classes.subtext },
	              "Join us as we introduce you to the email marketing system within your Elevate CRM\xAE. This training includes a platform overview of features for engaging your sphere, tips for staying top of mind, and best practices for providing valuable content to nurture your leads. Live Q&A throughout.",
	              _react2.default.createElement("br", null),
	              _react2.default.createElement("br", null),
	              "Training time:  1 hr."
	            ),
	            _react2.default.createElement(
	              "a",
	              { target: "_blank", href: "https://gateway.on24.com/wcc/eh/3767195/lp/3993322/elevate-email-marketing", className: classes.getStartedLink },
	              "Register Now"
	            ),
	            _react2.default.createElement(
	              "div",
	              { style: { textAlign: "center", paddingTop: "5px" } },
	              _react2.default.createElement("img", { src: _emerge_screen2.default, width: "300" })
	            )
	          ),
	          _react2.default.createElement("a", { id: "learn_more" })
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _BgSectionExternal2.default,
	      { bgImage: _webbottom_bg2.default,
	        secTitle: "On Demand Webinars",
	        secLink: "https://gateway.on24.com/wcc/eh/3767195/category/113505/elevate",
	        secButton: "View Recordings", secImage: _webinars2.default },
	      "Browse our ever-growing selection of on-demand Elevate training webinars, including our popular \u201CSecrets of Successful Lead Generation\u201D, \u201CHow to Promote Your Open Houses\u201D, and so much more just for you."
	    )
	  );
	};
	
	var query = exports.query = "** extracted graphql fragment **";
	
	exports.default = (0, _withStyles2.default)(function (theme) {
	  return {
	    root: {
	      position: "relative",
	      paddingTop: "20px"
	    },
	    top: {
	      display: "flex",
	      flexWrap: "wrap",
	      alignItems: "top"
	    },
	
	    column2: {
	      width: "530px",
	      maxWidth: "100%",
	      paddingRight: "20px",
	      paddingLeft: "20px",
	      verticalAlign: "top"
	    },
	
	    column3: {
	      width: "350px",
	      maxWidth: "100%",
	      paddingRight: "10px",
	      paddingLeft: "10px",
	      verticalAlign: "top"
	    },
	    getStartedLink: {
	      minWidth: "250px",
	      maxWidth: "250px",
	      alignContent: "center",
	      justifyContent: "center",
	      fontSize: "14px",
	      fontWeight: "700",
	      display: "block",
	      letterSpacing: ".25px",
	      backgroundColor: theme.colors.secondary,
	      color: "#FFF",
	      textDecoration: "none",
	      padding: "14px 16px",
	      borderRadius: "4px",
	      margin: "16px auto",
	      marginBottom: "20px"
	    },
	
	    getStartedLink2: {
	      minWidth: "250px",
	      maxWidth: "250px",
	      alignContent: "center",
	      justifyContent: "center",
	      fontSize: "14px",
	      fontWeight: "700",
	      display: "block",
	      letterSpacing: ".25px",
	      backgroundColor: "#83858a",
	      color: "#FFF",
	      textDecoration: "none",
	      padding: "14px 16px",
	      borderRadius: "4px",
	      margin: "16px auto",
	      marginBottom: "20px"
	    },
	    centerHeading: {
	      alignItems: "center",
	      width: "100%",
	      textAlign: "center"
	    },
	    bold: {
	      fontWeight: "700"
	    },
	    heading: {
	      color: "#2E2E35",
	      fontSize: "32px",
	      lineHeight: "36px",
	      fontWeight: "700",
	      marginRight: "auto"
	    },
	
	    subheading: {
	      color: "#2E2E35",
	      fontSize: "20px",
	      lineHeight: "24px",
	      fontWeight: "700",
	      paddingBottom: "15px"
	    },
	
	    subtext: {
	      fontSize: "16px",
	      fontWeight: "300",
	      lineHeight: "24px",
	      color: "#777777"
	    },
	
	    heading3: {
	      color: "#f15b54",
	      fontSize: "18px",
	      lineHeight: "40px",
	      fontWeight: "700",
	      marginRight: "auto",
	      paddingBottom: "10px"
	    },
	
	    heading2: {
	      color: theme.colors.secondary,
	      fontSize: "32px",
	      lineHeight: "40px",
	      fontWeight: "700",
	      marginRight: "auto",
	      paddingBottom: "20px"
	    },
	    bootcampLink: {
	      color: "inherit",
	      textDecoration: "none",
	      padding: "12px 0",
	
	      "&:hover": {
	        textDecoration: "underline"
	      }
	    },
	    grid: {
	      paddingTop: "96px",
	      paddingBottom: "120px"
	    },
	    backgroundSlice: {
	      position: "absolute",
	      top: "200px",
	      bottom: "0",
	      right: "0",
	      left: "0",
	      width: "100%",
	      height: "400px",
	      backgroundImage: "url('" + _overlappingHexagons2.default + "')",
	      opacity: "0.5",
	      zIndex: "-1"
	    },
	    backgroundTopSlice: {
	      position: "absolute",
	      top: "-1px",
	      width: "100%",
	      height: "10vw",
	      transform: "rotate(180deg)"
	    },
	    backgroundBottomSlice: {
	      position: "absolute",
	      bottom: "0",
	      width: "100%",
	      height: "10vw"
	    },
	    past: {
	      color: "#2E2E35",
	      fontSize: "28px",
	      fontWeight: "700",
	      paddingBottom: "20px",
	      borderBottom: "2px solid rgba(100, 97, 110, .20)"
	    },
	    pastContainer: {
	      display: "flex",
	      flexDirection: "column"
	    },
	    pastDesc: {
	      padding: "24px 0",
	      fontSize: "18px",
	      lineHeight: "26px"
	    },
	    pastLink: {
	      display: "flex",
	      alignContent: "center",
	      justifyContent: "center",
	      backgroundColor: "#2E7FC2",
	      fontSize: "14px",
	      letterSpacing: ".25px",
	      color: "#fff",
	      textDecoration: "none",
	      fontWeight: "600",
	      padding: "16px 16px",
	      borderRadius: "6px",
	      alignSelf: "flex-start",
	      marginLeft: "4px"
	    }
	  };
	})(Webinars);

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-webinars-js-2433cae39904875181b5.js